module.exports = __webpack_public_path__ + "static/media/ongoing-white.ebcbfdfc.svg";